import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AdvisorSessionRecoveryService } from '../../../services/auth/advisor-session-recovery.service';

@Component({
  selector: 'app-advisor-session-expired',
  standalone: true,
  imports: [RouterLink],
  template: `
    <main class="d-flex flex-column align-items-center justify-content-center text-center p-4" role="alert">
      <h1>Login mislykkedes</h1>
      <p>Din session er udløbet flere gange. Prøv at logge ind igen.</p>
      <button type="button" class="btn btn-primary" (click)="retryLogin()">Prøv igen</button>
      <a class="mt-3" routerLink="/">Til forsiden</a>
    </main>
  `,
})
export class AdvisorSessionExpiredComponent {
  constructor(private recovery: AdvisorSessionRecoveryService) {}

  retryLogin(): void {
    this.recovery.retryLogin();
  }
}
